import styled from "styled-components";
import {
  CardVehicleAndDriver,
  TripOrPlanningCard,
  dateFormatterDayMonthYear2Digits,
  dateFormatterHourMinute,
} from "@qivia/ui";
import { Tooltip } from "react-leaflet";
import { DomEvent } from "leaflet";
import { VehicleGeolocated } from "./index";
import { Trips, TripsDetails } from "../fleet/trips/tripsApi";

export const TooltipTripCard = (props: {
  vehicle: VehicleGeolocated;
  trip: TripsDetails;
  driver: Trips["driver"];
  dataPointDate: string;
  onRequestAddresses?: () => void;
  isPollingAddresses?: boolean;
}) => {
  const { vehicle, trip, driver, dataPointDate } = props;

  return (
    <Tooltip
      direction="top"
      offset={[0, -20]}
      opacity={1}
      permanent={true}
      interactive={props.onRequestAddresses !== undefined}
      className="vehicle-tooltip"
    >
      <StyledCardWrapper
        ref={(card) => card && DomEvent.disableClickPropagation(card)}
      >
        <TripOrPlanningCard
          type="TRIP"
          dataDisplay={{
            distance: trip.distance,
            duration: Math.round((trip.secondsDuration ?? 0) / 60),
            startDate: trip.startDate,
            endDate: trip.endDate,
            departureAddress: trip.departureAddress,
            destinationAddress: trip.destinationAddress,
            // ecoDrivingScore: trip.ecoDrivingScore,
            driver: driver ? `${driver.firstName} ${driver.lastName}` : null,
            clientName: null,
            clientCity: null,
            hasKmClient: false,
            activityType: null,
            isOutIntervention: false,
          }}
          onRequestAddresses={props.onRequestAddresses}
          isPollingAddresses={props.isPollingAddresses}
          headerProps={
            <CardVehicleAndDriver
              vehicle={vehicle}
              badgeText={vehicle.reference}
              rightElement={
                <StyledHour>
                  <div>
                    {dateFormatterDayMonthYear2Digits(new Date(dataPointDate))}
                  </div>
                  {dateFormatterHourMinute(new Date(dataPointDate)).replaceAll(
                    ":",
                    "h",
                  )}
                </StyledHour>
              }
              distance={vehicle.distance || 0}
              onClick={() => undefined}
              $withShadow={false}
            />
          }
        />
      </StyledCardWrapper>
    </Tooltip>
  );
};

const StyledCardWrapper = styled.div`
  width: fit-content;
  min-width: 24rem;
`;

const StyledHour = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
